/** @jsx h */
import { h, Component } from 'preact'
import Chevron from './icons/Chevron'
import TagLine from '../TagLine'
import VerifiedTick from '../icons/VerifiedTickIcon'

import { initSingleLocationMap } from '../../../modules/mapbox'
import { mapBoxStyleLight } from './CollaborationCard'

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]

class CollaborationBack extends Component {
  componentDidMount () {
    initSingleLocationMap(
      $('.Mapbox-map--collaboratorBackCard'),
      $('.Mapbox-map--collaboratorBackCard').attr('id'),
      true
    )
  }

  render () {
    const { claim, flipCard } = this.props

    const verifiedDate = new Date(claim.createdAt)
    const dateString = `${verifiedDate.getDate()} ${monthNames[
      verifiedDate.getMonth()
    ].substring(0, 3)} ${verifiedDate.getFullYear()}`
    const coordinates = claim.location
      ? `[${claim.location.longitude}, ${claim.location.latitude}]`
      : 'unknown'

    return (
      <div class='ClaimCard ClaimCard-back--collaboration'>
        <div class='Mapbox ClaimCard-interactiveMap--collaboration'>
          <div
            class='Mapbox-map Mapbox-map--nonInteractive Mapbox-map--collaboratorBackCard'
            data-coordinates={coordinates}
            data-styleid={mapBoxStyleLight}
            id={`Mapbox-map--collaboratorBack-${claim.id}`}
          />
          <div class='Mapbox-overlay' />
        </div>
        <div class='ClaimCard-logo ClaimCard-logo--gradient'>
          <TagLine />
          <div class='ClaimCard--verification'>
            <VerifiedTick />
            <div class='ClaimCard-text--verification Text-headingSmall'>
              Verified:
              <span class='ClaimCard-text--verificationDate'>
                {' '}
                {dateString}
              </span>
            </div>
          </div>
        </div>
        <button
          class='ClaimCard-action ClaimCard-action--evidence ClaimCard-action--back'
          onClick={flipCard}
          type='button'
        >
          <Chevron />
        </button>
      </div>
    )
  }
}

export default CollaborationBack
